import { Level2MenuHead, Level2MenuItem } from "@/features";
import React, { ReactElement, useContext } from "react";
import { useTextDomainContext } from "@/app/providers";
import type { GgMeType } from "@/types";
import { FaHandshake } from "react-icons/fa6";
import {
  getRoleTypeNameFromUser,
  permissionsPartnerMenu,
  permissionsSettings,
  permissionsUsersReadonly,
  permissionsTenantsReadonly,
  permissionsLocationsReadonly,
} from "@/utils";

const parentPath = "partner-admin";

interface PartnerMenuProps {
  user?: GgMeType | null;
}

export const PartnerMenu = ({
  user,
}: PartnerMenuProps): ReactElement | null => {
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);
  const roleType = getRoleTypeNameFromUser(user);

  if (roleType !== "partner" && roleType !== "super") {
    return null;
  }

  return (
    <Level2MenuHead
      link={`/${parentPath}`}
      label={gettext("Partner")}
      codes={permissionsPartnerMenu}
      feature="common"
      icon={<FaHandshake />}
    >
      <Level2MenuItem
        link={`/${parentPath}/settings`}
        label={gettext("Settings")}
        codes={permissionsSettings}
        feature="common"
      />
      <Level2MenuItem
        link={`/${parentPath}/partner-users`}
        label={gettext("Users")}
        codes={permissionsUsersReadonly}
        feature="common"
      />
      <Level2MenuItem
        link={`/${parentPath}/tenants`}
        label={gettext("Corporate Groups")}
        codes={permissionsTenantsReadonly}
        feature="common"
      />
      <Level2MenuItem
        link={`/${parentPath}/locations`}
        label={gettext("Company Location")}
        codes={permissionsLocationsReadonly}
        feature="common"
      />
    </Level2MenuHead>
  );
};
